





































































































































import DraggableDataTable from '@/components/ApplicationProcessing/DraggableDataTable.vue';
import CreatePretension from '@/components/Pretensions/CreatePretension.vue';
import { TableData } from '@/types/DraggableDataTableTypes';
import DateFilter from '@/components/common/DateFilter.vue';
import DateRange from '@/components/common/DateRange.vue';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { DataPagination } from 'vuetify';
import PretensionController from '@/controllers/Pretension';
import EntityHelperMixin from '@/mixins/EntityHelperMixin';
import { Pretension, PretensionStatus, PretensionType } from '@/types/Pretension';
import FilterBuilder from '@/classes/pimcore-filtering/FilterBuilder';

import _ from 'lodash';

import {
  like, and, or,
} from '@/classes/pimcore-filtering/Filters';
import UserMixin from '@/mixins/UserMixin';

@Component({
  components: {
    DraggableDataTable,
    CreatePretension,
    DateFilter,
    DateRange,
  },
})
export default class Pretensions extends Mixins(EntityHelperMixin, UserMixin) {
  @Prop({
    type: String,
    required: false,
    default: 'Pretensions',
  }) readonly localStoragePrefix!: string;

  headers = [
    {
      text: 'ID',
      value: 'id',
    },
    {
      text: 'Номер документа',
      value: 'sequence',
    },
    {
      text: 'Тип',
      value: 'typeName',
    },
    {
      text: 'Дата создания',
      value: 'created_at',
    },
    {
      text: 'Дата с',
      value: 'date_from',
    },
    {
      text: 'Дата по',
      value: 'date_to',
    },
    {
      text: 'Поставщик',
      value: 'supplier_legal_name',
    },
    {
      text: 'Платформа',
      value: 'platform_name',
    },
    {
      text: 'Сумма',
      value: 'total_without_tax',
    },
  ]

  get defaultPagination(): DataPagination {
    return _.cloneDeep({
      page: 1,
      pageStart: 0,
      itemsPerPage: 10,
      pageStop: 0,
      pageCount: 0,
      itemsLength: 0,
    });
  }

  tables: Array<TableData> = [
    {
      status: PretensionStatus.CREATED,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.SIGNER_SIGNING_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.SUPPLIER_SIGNING_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.ACCOUNTING_APPROVE_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.PAYMENT_AWAIT,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.PAYMENT_DONE,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
    {
      status: PretensionStatus.RECALLED,
      items: [{}],
      loading: true,
      disableDraggable: true,
      pagination: this.defaultPagination,
    },
  ];

  loadingPage = false;

  dates: Array<any> = [];

  defaultDates: Array<any> = [];

  platformsList: Array<any> = [];

  selectedPlatform = '';

  defaultPlatform = '';

  suppliersList: Array<any> = [];

  selectedSuppliers: Array<any> = [];

  pretensionTypesList: Array<{ name: string; value: PretensionType }> = [
    {
      name: 'Штраф',
      value: 'fine',
    },
    {
      name: 'Ущерб',
      value: 'damage',
    },
  ];

  selectedType = this.getFromStorage('type');

  async beforeMount() {
    this.loadingPage = true;
    this.calculateDefaultDates();
    this.platformsList = await this.loadEntityListing('PlantsHR', undefined, 'network-only', { maxDepth: 1 });
    this.defaultPlatform = this.platformsList[0]?.id;
    this.selectedPlatform = this.getFromStorage('platform') || this.defaultPlatform;
    this.suppliersList = await this.loadSuppliers();
    this.selectedSuppliers = this.getFromStorage('suppliers')
      .split(',')
      .filter((supplierId) => supplierId.trim() !== '');
    await this.reloadTables();
    this.loadingPage = false;
  }

  calculateDefaultDates() {
    const dateNow = new Date();
    const dateAgo = new Date();
    dateAgo.setMonth(dateAgo.getMonth() - 1);
    dateAgo.setDate(1);
    this.defaultDates = [dateAgo.toISOString().split('T')[0], dateNow.toISOString().split('T')[0]];
  }

  async reloadTables() {
    this.loadingPage = true;
    const promises: Array<Promise<any>> = [];
    for (let i = 0; i < this.tables.length; i += 1) {
      const table = this.tables[i];
      promises.push(this.reloadTable(table));
    }
    await Promise.all(promises);
    this.loadingPage = false;
  }

  async reloadTable(table: TableData) {
    const currentIndex = this.tables.findIndex((v: TableData) => v.status === table.status);
    this.tables[currentIndex].loading = true;
    const currentTable = this.tables[currentIndex];
    currentTable.pagination = table.pagination || this.defaultPagination;
    const { data, total } = await this.loadPretensions(currentTable.pagination, currentTable.status);
    currentTable.items = this.handleData(data);
    currentTable.pagination.itemsLength = total;
    currentTable.pagination.pageCount = Math.ceil(total / currentTable.pagination.itemsPerPage);
    currentTable.loading = false;
    this.$set(this.tables, currentIndex, currentTable);
  }

  async loadPretensions(pagination: DataPagination, status: string): Promise<{ data: Array<Pretension>; total: number }> {
    const { page, itemsPerPage } = pagination;
    const resp = await PretensionController.list({
      pageFrom: (page - 1) * itemsPerPage,
      pageSize: itemsPerPage,
      status,
      createdAt: this.dates,
      platformId: this.selectedPlatform,
      suppliers: this.selectedSuppliers,
      type: this.selectedType,
    });
    if (resp.result[0]) {
      this.$bus.$emit('notification', `${resp.result[0]}`, 'error');
      return { data: [], total: 0 };
    }
    return resp.result[1];
  }

  async loadSuppliers() {
    return this.loadEntityListing('Supplier', {
      filter: (new FilterBuilder()).addFilters(and(like('PlantsHR', `%${this.selectedPlatform}%`))).build(),
    }, 'network-only', { maxDepth: 1 });
  }

  handleData(data: Pretension[]): Pretension[] {
    const copy = data.map((item) => {
      const clonedObj = { ...item, typeName: String(this.$t(item.type)) };
      return clonedObj;
    });
    return copy;
  }

  changeDates(dates: Array<string>) {
    this.dates = dates;
  }

  changeSuppliers(suppliers: Array<any>) {
    this.selectedSuppliers = suppliers;
    this.setToStorage('suppliers', suppliers.join(','));
  }

  async changePlatform(platform: string) {
    this.selectedPlatform = platform;
    this.selectedSuppliers = [];
    this.setToStorage('platform', platform);
    this.setToStorage('suppliers', '');
    this.suppliersList = await this.loadSuppliers();
  }

  changeType(type: string) {
    this.selectedType = type;
    this.setToStorage('type', type);
  }

  dragChange(event: any, table: any) {
    // await this.reloadTable(table);
    // send request to move item to next status
    // on successful status change or fail - reload both tables
    console.log('change', event, table);
  }

  move(item: any, to: any) {
    console.log('move', item, to);
  }

  clickRow(event: any) {
    if (event?.id) {
      this.$router.push({ name: 'PretensionPage', params: { id: event.id } });
    }
  }

  async onPagination(pagination: DataPagination, table: TableData) {
    if (pagination.itemsPerPage === table?.pagination?.itemsPerPage && pagination.pageStart === table?.pagination?.pageStart) {
      return;
    }
    table.loading = true;
    table.pagination = pagination;
    await this.reloadTable(table);
    table.loading = false;
  }

  filtersChanged(): boolean {
    return this.selectedSuppliers.length > 0
      || this.selectedType !== ''
      || this.selectedPlatform !== this.defaultPlatform
      || this.dates.length !== 2
      || this.dates[0] !== this.defaultDates[0]
      || this.dates[1] !== this.defaultDates[1];
  }

  clearFilters() {
    this.changeType('');
    this.changePlatform(this.defaultPlatform);
    this.$bus.$emit('clear-filters');
  }
}
